import { createAction, props } from '@ngrx/store'
import { PermissionSetAssignedTo, PermissionSet } from './permission-sets.state'
import { User } from '../auth/auth.state'

interface ApiPermissionPayload {
  moduleId: string
  permissionIds: string[]
}

// Action to load Department
export const loadPermissionSets = createAction(
  '[PermissionSet] Load Permission Set',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful Family load
export const loadPermissionSetsSuccess = createAction(
  '[PermissionSet] Load Permission Set Success',
  props<{
    totalCount: number
    permissionSets: PermissionSet[]
  }>()
)

// Action for Department load failure
export const loadPermissionSetsFailure = createAction(
  '[PermissionSet] Load Permission Set Failure',
  props<{ error: string }>()
)

// Create Permission Set
export const createPermissionSet = createAction(
  '[PermissionSet] Create Permission Set',
  props<{
    name: string
    // permissions: Record<string, PermissionAction[]> // 👈 better typing
    permissions: ApiPermissionPayload[]
    isStandard?: boolean
    businessId: string
  }>()
)

export const createPermissionSetSuccess = createAction(
  '[PermissionSet] Create Permission Set Success',
  props<{ permissionSet: PermissionSet }>()
)

export const createPermissionSetFailure = createAction(
  '[PermissionSet] Create Permission Set Failure',
  props<{ error: string }>()
)

//Update Permission Set
export const updatePermissionSet = createAction(
  '[PermissionSet] Update Permission Set',
  props<{
    id: string
    name: string
    // permissions: Record<string, PermissionAction[]> // 👈 better typing
    permissions: ApiPermissionPayload[]

    isStandard?: boolean
    businessId: string
  }>()
)

export const updatePermissionSetSuccess = createAction(
  '[PermissionSet] Update Permission Set Success',
  props<{ permissionSet: PermissionSet }>()
)

export const updatePermissionSetFailure = createAction(
  '[PermissionSet] Update Permission Set Failure',
  props<{ error: string }>()
)

// Action to initiate loading of Permission Set by ID
export const loadPermissionSetById = createAction(
  '[PermissionSet] Load Permission Set By ID',
  props<{ id: string }>()
)

// Action when Permission Set data is loaded successfully
export const loadPermissionSetByIdSuccess = createAction(
  '[PermissionSet] Load Permission Set By ID Success',
  props<{ permissionSet: PermissionSet }>()
)

// Action when there is an error loading the Permission Set data
export const loadPermissionSetByIdFailure = createAction(
  '[PermissionSet] Load Permission Set By ID Failure',
  props<{ error: string }>()
)

export const resetPermissionSetState = createAction('[Permission Set] Reset State')

//Load Assigned To
export const loadAssignedTo = createAction(
  '[Permission Set] Load Assigned To',
  props<{ permissionSetId: string }>()
)
export const loadAssignedToSuccess = createAction(
  '[Permission Set] Load Assigned To Success',
  props<{ totalCount: number; assignedPermissionSets: PermissionSetAssignedTo[] }>()
)
export const loadAssignedToFailure = createAction(
  '[Permission Set] Load Assigned To Failure',
  props<{ error: string }>()
)

//Creaete Assigned To
export const createAssignedTo = createAction(
  '[Permission Set] Create Assigned To',
  props<{ permissionSetId: string; userData: { userId: string }[]; businessId: string | null }>()
)

export const createAssignedToSuccess = createAction(
  '[PermissionSet] Create Assigned To Success',
  props<{ assignedTo: PermissionSetAssignedTo[] }>()
)

export const createAssignedToFailure = createAction(
  '[PermissionSet] Create Assigned To Failure',
  props<{ error: string }>()
)

//Upsert Valid Upto
export const upsertValidUpto = createAction(
  '[PermissionSet] Upsert Valid Upto',
  props<{ id: string; validUpto: Date | null }>()
)
export const upsertValidUptoSuccess = createAction(
  '[PermissionSet] Upsert Valid Upto Success',
  props<{ assignedTo: PermissionSetAssignedTo[] }>()
)
export const upsertValidUptoFailure = createAction(
  '[PermissionSet] Upsert Valid Upto Failure',
  props<{ error: string }>()
)

//Delete Assigned To
export const deleteAssignedTo = createAction(
  '[PermissionSet] Delete Assigned To',
  props<{ id: string }>()
)
export const deleteAssignedToSuccess = createAction(
  '[PermissionSet] Delete Assigned To Success',
  props<{ assignedTo: PermissionSetAssignedTo[] }>()
)
export const deleteAssignedToFailure = createAction(
  '[PermissionSet] Delete Assigned To Failure',
  props<{ error: string }>()
)

export const loadUnassignedUsers = createAction(
  '[PermissionSet] Load Unassigned Users',
  props<{
    permissionSetId: string
    businessId: string | null
    businessIdtoAssign: string | null
  }>()
)

export const loadUnassignedUsersSuccess = createAction(
  '[PermissionSet] Load Unassigned Users Success',
  props<{ users: User[]; totalUserCount: number }>()
)

export const loadUnassignedUsersFailure = createAction(
  '[PermissionSet] Load Unassigned Users Failure',
  props<{ error: any }>()
)

export const clearUnassignedUsers = createAction('[PermissionSet] Clear Unassigned Users')
